/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : 'CartCount',
      cartCostSelector   : null,    
      moneyFormat        : DT_THEME.moneyFormat,      
      disableAjaxCart    : false,
      enableQtySelectors : true
    };
  
    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);    
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        //$cartCountSelector.addClass('hidden');
         $('#CartCount').addClass('hidden');
      }
      if (cart.item_count > 0) {
        $('#CartCount').removeClass('hidden');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        var $addButtoncontainer = $formContainer.find('.product-add');
        $addButtoncontainer.before('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);  
    
  };

  // buildCart = function(cart) {
  
  //   var CartTotal =  Shopify.formatMoney(cart.total_price).replace(/(\.0+|0+)$/, '').replace(/,/g, '').trim().replace(/\D/g, '');
  //   var GoalCheck = DT_THEME.cartGoalPrice;
  //   var dif = GoalCheck - CartTotal;

  //   var GoalCheck = Math.round(GoalCheck);
  //   //const progress = Math.round((CartTotal / GoalCheck) * 100)
    
  //    if (CartTotal > GoalCheck) {
  //      var  resultExpected = DT_THEME.freeEligible;
  //      var resultExpectedClass="free-pass";
  //    }else{   
  //   var  resultExpected =  DT_THEME.freeOnly+" " + Shopify.formatMoney(dif+'.00', settings.moneyFormat)+" "+ DT_THEME.freeNotEligible;
  //      var resultExpectedClass="free-fail";
  //    }
       

       
    
  //   // Start with a fresh cart div
  //   $cartContainer.empty();

  //   // Show empty cart
  //   if (cart.item_count === 0) {
  //     $cartContainer
  //       .append('<h5 class="cart-content">' +DT_THEME.strings.emptyCart+ '<a class="dt-sc-btn" href="/collections/all">'+DT_THEME.strings.continueShopping+'</a></h5>');
  //     cartCallback(cart);
  //     return;
  //   }

  //   // Handlebars.js cart layout
  //   var items = [],
  //     item = {},
  //     data = {},
  //     source = $('#CartTemplate').html(),
  //     template = Handlebars.compile(source);

  //   // Add each item to our handlebars.js data
  //   $.each(cart.items, function(index, cartItem) {
  //     /* Hack to get product image thumbnail
  //      *   - If image is not null
  //      *     - Remove file extension, add _small, and re-add extension
  //      *     - Create server relative link
  //      *   - A hard-coded url of no-image
  //     */
      
         
        
  //     var prodImg;
  //     if (cartItem.image !== null) {
  //       prodImg = cartItem.image
  //         .replace(/(\.[^.]*)$/, '_medium$1')
  //         .replace('http:', '');
  //     } else {
  //       prodImg =
  //         '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
  //     }

  //     if (cartItem.properties !== null) {
  //       $.each(cartItem.properties, function(key, value) {
  //         if (key.charAt(0) === '_' || !value) {
  //           delete cartItem.properties[key];
  //         }
  //       });
  //     }

  //     if (cartItem.properties !== null) {
  //       $.each(cartItem.properties, function(key, value) {
  //         if (key.charAt(0) === '_' || !value) {
  //           delete cartItem.properties[key];
  //         }
  //       });
  //     }

  //     if (cartItem.line_level_discount_allocations.length !== 0) {
  //       for (var discount in cartItem.line_level_discount_allocations) {
  //         var amount =
  //           cartItem.line_level_discount_allocations[discount].amount;

  //         cartItem.line_level_discount_allocations[
  //           discount
  //         ].formattedAmount = Shopify.formatMoney(
  //           amount,
  //           settings.moneyFormat
  //         );
  //       }
  //     }

  //     if (cart.cart_level_discount_applications.length !== 0) {
  //       for (var cartDiscount in cart.cart_level_discount_applications) {
  //         var cartAmount =
  //           cart.cart_level_discount_applications[cartDiscount]
  //             .total_allocated_amount;

  //         cart.cart_level_discount_applications[
  //           cartDiscount
  //         ].formattedAmount = Shopify.formatMoney(
  //           cartAmount,
  //           settings.moneyFormat
  //         );
  //       }
  //     }

     
      
  //     // Create item's data object and add to 'items' array
  //     item = {
  //       key: cartItem.key,
  //       line: index + 1, // Shopify uses a 1+ index in the API
  //       url: cartItem.url,
  //       img: prodImg,
  //       name: cartItem.product_title,
  //       variation: cartItem.variant_title,
  //       properties: cartItem.properties,
  //       itemAdd: cartItem.quantity + 1,
  //       itemMinus: cartItem.quantity - 1,
  //       itemQty: cartItem.quantity,
  //       price: Shopify.formatMoney(
  //         cartItem.original_line_price,
  //         settings.moneyFormat
  //       ),
  //       discountedPrice: Shopify.formatMoney(
  //         cartItem.final_line_price,
  //         settings.moneyFormat
  //       ),
  //       discounts: cartItem.line_level_discount_allocations,
  //       discountsApplied:
  //         cartItem.line_level_discount_allocations.length === 0 ? false : true,
  //       vendor: cartItem.vendor
  //     };

  //     items.push(item);
  //   });

  //   // Gather all cart data and add to DOM
     
  //   data = {
  //     items: items,
  //     note: cart.note,
  //     subTotalPrice: Shopify.formatMoney(
  //       cart.items_subtotal_price,
  //       settings.moneyFormat
  //     ),
  //     totalPrice: Shopify.formatMoney(
  //       cart.total_price,
  //       settings.moneyFormat
  //     ),
  //     cartTotalDiscounts: Shopify.formatMoney(
  //       cart.total_discount,
  //       settings.moneyFormat
  //     ),
  //     cartDiscounts: cart.cart_level_discount_applications,
  //     cartDiscountsApplied:
  //       cart.cart_level_discount_applications.length === 0 ? false : true,
  //     cartTotalSavings: cart.cart_level_discount_applications.length === 0 && cart.total_discount > 0,
  //     //        shippingMessageHTML1: GoalCheck,
  //     //        shippingMessageHTML2: DT_THEME.cartGoalPrice,       
  //     // GoalCheck < DT_THEME.cartGoalPrice ? 'Only ' + Shopify.formatMoney(dif, settings.moneyFormat) + ' away! for shipping' : 'Yahoo! you got free shipping!',
  //     shippingMessageHTML: resultExpected,
  //     shippingMessageClass: resultExpectedClass
  //   };

  //   $cartContainer.append(template(data));

  //   cartCallback(cart);
   
  // };


buildCart = function(cart) {

  var CartTotal = Shopify.formatMoney(cart.total_price)
    .replace(/(\.0+|0+)$/, '')
    .replace(/,/g, '')
    .trim()
    .replace(/\D/g, '');

  var GoalCheck = DT_THEME.cartGoalPrice;
  var dif = GoalCheck - CartTotal;

  GoalCheck = Math.round(GoalCheck);

  var resultExpected;
  var resultExpectedClass;

  if (CartTotal > GoalCheck) {

    resultExpected = DT_THEME.freeEligible;
    resultExpectedClass = "free-pass";

  } else {

    resultExpected =
      DT_THEME.freeOnly +
      " " +
      Shopify.formatMoney(
        dif + '.00',
        settings.moneyFormat
      ) +
      " " +
      DT_THEME.freeNotEligible;

    resultExpectedClass = "free-fail";
  }


  // Clear cart container
  $cartContainer.empty();


  // Empty cart
  if (cart.item_count === 0) {

    $cartContainer.append(
      '<h5 class="cart-content">' +
      DT_THEME.strings.emptyCart +
      '<a class="dt-sc-btn" href="/collections/all">' +
      DT_THEME.strings.continueShopping +
      '</a></h5>'
    );

    cartCallback(cart);
    return;
  }


  // Handlebars
  var items = [];
  var source = $('#CartTemplate').html();
  var template = Handlebars.compile(source);

  var totalCompareAtSavings = 0;

  /*
   * IMPORTANT:
   * Create an item immediately.
   * Do NOT wait for product JSON before adding
   * the item to the cart.
   */

  $.each(cart.items, function(index, cartItem) {

    var prodImg;

    if (cartItem.image !== null) {

      prodImg = cartItem.image
        .replace(/(\.[^.]*)$/, '_medium$1')
        .replace('http:', '');

    } else {

      prodImg =
        '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
    }


    /*
     * Product properties
     */
    if (cartItem.properties !== null) {

      $.each(cartItem.properties, function(key, value) {

        if (key.charAt(0) === '_' || !value) {
          delete cartItem.properties[key];
        }

      });

    }


    /*
     * Line discounts
     */
    if (
      cartItem.line_level_discount_allocations &&
      cartItem.line_level_discount_allocations.length !== 0
    ) {

      $.each(
        cartItem.line_level_discount_allocations,
        function(discountIndex, discount) {

          discount.formattedAmount =
            Shopify.formatMoney(
              discount.amount,
              settings.moneyFormat
            );

        }
      );

    }


    /*
     * Cart discounts
     */
    if (
      cart.cart_level_discount_applications &&
      cart.cart_level_discount_applications.length !== 0
    ) {

      $.each(
        cart.cart_level_discount_applications,
        function(discountIndex, cartDiscount) {

          cartDiscount.formattedAmount =
            Shopify.formatMoney(
              cartDiscount.total_allocated_amount,
              settings.moneyFormat
            );

        }
      );

    }


    /*
     * ========================================================
     * DEFAULT VALUES
     * ========================================================
     */

    var compareAtPrice = 0;

    var sellingPrice =
      parseInt(
        cartItem.original_price || 0,
        10
      );

    var quantity =
      parseInt(
        cartItem.quantity || 1,
        10
      );

    var unitSaving = 0;

    var totalProductSaving = 0;


    /*
     * ========================================================
     * CREATE ITEM IMMEDIATELY
     * ========================================================
     */

    items[index] = {

      key: cartItem.key,

      line: index + 1,

      url: cartItem.url,

      img: prodImg,

      name: cartItem.product_title,

      variation: cartItem.variant_title,

      properties: cartItem.properties,

      itemAdd: quantity + 1,

      itemMinus: quantity - 1,

      itemQty: quantity,

      price: Shopify.formatMoney(
        cartItem.original_line_price,
        settings.moneyFormat
      ),

      discountedPrice: Shopify.formatMoney(
        cartItem.final_line_price,
        settings.moneyFormat
      ),

      /*
       * These are updated if compare-at price
       * is successfully loaded.
       */
      compareAtPrice:
        Shopify.formatMoney(
          0,
          settings.moneyFormat
        ),

      unitSaving:
        Shopify.formatMoney(
          0,
          settings.moneyFormat
        ),

      totalSaving:
        Shopify.formatMoney(
          0,
          settings.moneyFormat
        ),

      compareAtPriceValue: 0,

      unitSavingValue: 0,

      totalSavingValue: 0,

      hasCompareAtSaving: false,

      discounts:
        cartItem.line_level_discount_allocations || [],

      discountsApplied:
        cartItem.line_level_discount_allocations &&
        cartItem.line_level_discount_allocations.length !== 0,

      vendor: cartItem.vendor
    };


    /*
     * ========================================================
     * LOAD PRODUCT JSON
     * ========================================================
     */

    var productPath =
      (cartItem.url || '').split('?')[0];

    if (!productPath) {
      return;
    }


    $.getJSON(productPath + '.js')

      .done(function(product) {

        var variant = null;


        /*
         * Find matching variant
         */
        if (product && product.variants) {

          $.each(
            product.variants,
            function(variantIndex, productVariant) {

              if (
                String(productVariant.id) ===
                String(cartItem.variant_id)
              ) {

                variant = productVariant;

                return false;
              }

            }
          );

        }


        /*
         * Get compare-at price
         */
        if (
          variant &&
          variant.compare_at_price !== null &&
          parseInt(
            variant.compare_at_price,
            10
          ) > 0
        ) {

          compareAtPrice =
            parseInt(
              variant.compare_at_price,
              10
            );

        }


        /*
         * Calculate saving
         */
        if (
          compareAtPrice > 0 &&
          compareAtPrice > sellingPrice
        ) {

          unitSaving =
            compareAtPrice -
            sellingPrice;

          totalProductSaving =
            unitSaving *
            quantity;

        }


        /*
         * Add to total savings
         */
        totalCompareAtSavings +=
          totalProductSaving;


        /*
         * Update existing item
         */
        items[index].compareAtPrice =
          Shopify.formatMoney(
            compareAtPrice * quantity,
            settings.moneyFormat
          );

        items[index].unitSaving =
          Shopify.formatMoney(
            unitSaving,
            settings.moneyFormat
          );

        items[index].totalSaving =
          Shopify.formatMoney(
            totalProductSaving,
            settings.moneyFormat
          );

        items[index].compareAtPriceValue =
          compareAtPrice;

        items[index].unitSavingValue =
          unitSaving;

        items[index].totalSavingValue =
          totalProductSaving;

        items[index].hasCompareAtSaving =
          totalProductSaving > 0;

      })

      .always(function() {

        /*
         * This is intentionally empty.
         *
         * The cart item already exists in items[].
         * Product JSON is only used to improve
         * the savings information.
         */

      });

  });


  /*
   * ========================================================
   * RENDER CART IMMEDIATELY
   * ========================================================
   *
   * This guarantees that the products appear.
   */

  var shopifyDiscounts =
    parseInt(
      cart.total_discount || 0,
      10
    );


  /*
   * Initial render
   */
  var totalSavings =
    shopifyDiscounts;


  data = {

    items: items,

    note: cart.note,

    subTotalPrice:
      Shopify.formatMoney(
        cart.items_subtotal_price,
        settings.moneyFormat
      ),

    totalPrice:
      Shopify.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ),

    cartTotalDiscounts:
      Shopify.formatMoney(
        totalSavings,
        settings.moneyFormat
      ),

    cartTotalSavingsValue:
      totalSavings,

    cartDiscounts:
      cart.cart_level_discount_applications,

    cartDiscountsApplied:
      cart.cart_level_discount_applications.length !== 0,

    cartTotalSavings:
      totalSavings > 0,

    shippingMessageHTML:
      resultExpected,

    shippingMessageClass:
      resultExpectedClass
  };


  /*
   * Render drawer
   */
  $cartContainer.append(
    template(data)
  );


  /*
   * Callback
   */
  cartCallback(cart);

};






  

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);

     if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
    
    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),      
          qty = parseInt($qtySelector.val());      
          if (!isNaN(qty)) {
            var qty = validateQty(qty); 
          }
          else
          {
            qty = 0;
          }

      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
    

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);      
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
     
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };



  return module;

}(ajaxCart || {}, jQuery));
